<div id="wrapper" class="purchase-page top-level-page bs-enabled min-vh-100">

	<notification-toaster-component></notification-toaster-component>

    <!-- header -->
    <header class="header pt-3 pb-2" id="header">
        <div class="header-wrap w-100 flex-row align-items-center justify-content-between">
            <div class="header-logo-container">
                <a href="https://trustifi.com/" class="header-logo">
                    <img src="images/logo.png" alt="logo" class="template-image color-logo-image" style="max-width: 160px;">
                </a>
            </div>
            <div class="flex-row align-items-center gap-2">
                <div class="request-demo-btn-container rounded p-2" style="border: 1px solid #9ee3b4;">
                    <a class="link-btn small-btn" href="https://trustifi.com/get-a-quote/">
						<i class="far fa-arrow-left me-1"></i>
						Go Back
                    </a>
                </div>
                <div class="request-demo-btn-container rounded p-2 border-none " style="background-color: #9ee3b4;">
                    <a href="https://trustifi.com/get-a-quote/" class="link-btn small-btn">
                        Get A Quote
                    </a>
                </div>
            </div>
        </div>
    </header>

	<div class="main-content flex-column">
		<!-- content -->
		<div class="w-100">
			<div class="d-flex flex-column flex-xl-row gap-4 flex-wrap align-items-start">
				<!-- Features Column -->
				<div class="content-column order-2 order-md-1 ">
					<div class="flex-column flex-md-row flex-wrap gap-3">
						<div class="w-100 flex-column align-items-center mb-4">
							<h1 class="fw-bold mb-2 text-primary" style="font-size:2.2rem; text-align: center;">Purchase Licenses Now</h1>
							<h2 class="regular-title text-dark text-muted" style="font-size: 1.25rem; text-align: center;">
								Everything you need to keep yourself or your organization protected
							</h2>
						</div>
						<!-- CC: restructured feature cards with updated product name and reordered feature hierarchy -->
						<div class="card-content shadow-sm p-4 rounded">
							<h3 class="fw-bold text-primary" style="color: #2b3f69;">
								<i class="far fa-shield me-2" style="font-size: 1.1em"></i>
								Trustifi Email Security Suite
							</h3>
							<span class="text-muted" style="font-size: 0.9em;">Inbound & Outbound Protection</span>
							<div class="flex-column gap-2 mt-2">
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Inbound Threat Protection</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Email Encryption</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Account Takeover Protection</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Domain Protection</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Multi-Factor Authentication</span>
								</div>
							</div>
						</div>
						<div class="card-content shadow-sm p-4 rounded">
							<h3 class="fw-bold text-primary" style="color: #2b3f69;">
								More Features:
							</h3>
							<div class="flex-column gap-2">
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Email Server Integration: Microsoft 365 & Google Workspace</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Email Tracking</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Secure File Storage: Encrypted File Sharing</span>
								</div>
								<div class="flex-row align-items-start gap-2">
									<i class="far fa-check position-relative text-success" style="font-size: 0.6rem; top: 3px;"></i>
									<span>Advanced Management Portal</span>
								</div>
							</div>
						</div>
						<div class="card-content shadow-sm rounded">
							<div class="h-100 flex-column gap-3 centralize p-3 rounded shadow-sm" style="background-color: #f9f9fa;">
								<span style="font-size: 1.1rem;">Need more than 10 users?</span>
								<span class="text-muted">Contact our sales team for enterprise pricing and custom solutions</span>
								<a href="https://www.trustifi.com/get-a-quote/" class="blue-link" style="font-size: 1rem;">Get a custom quote</a>
							</div>
						</div>
					</div>
				</div>
				<!-- Registration & Pricing Column -->
				<div class="content-column order-1 order-md-2">
					<div class="d-flex flex-column rounded overflow-hidden shadow position-relative" style="border: 1px solid #d8e1ef;">
						<div class="p-4 d-flex centralize gradient-primary">
							<span class="text-white" style="text-align: center; font-size: 1.25rem;">Complete Your Purchase</span>
						</div>
						<div class="flex-column p-3">
							<signup-form-component class="bs-enabled f-1-0" id="signupForm"
							   #signupFormEl
							   style="width: 100%; min-height: 290px; padding: 0; font-size: initial; border-bottom: 1px solid #e5e5e5; margin-bottom: 0.5rem; padding-bottom: 0.8rem;"
							   [signupData]="signupData"
							   [isPurchasePage]="true">
							</signup-form-component>

							<div class="mt-2">
								<form action='' class="quantity-form" autocomplete="off">
									<div class="d-flex align-items-center justify-content-between mb-2" style="font-size: 14px;">
										<label for="quantity-input" class="form-label me-3 mb-0"><i class="far fa-user me-1"></i> Number of licenses</label>
										<input class="form-control w-auto" id="quantity-input"
											   name="quantity" type="number"
											   [(ngModel)]="numUsers"
											   (change)="validateMinMaxUsers(numUsers)"
											   pattern="/^[1-9]$|^1[0-9]$|^20$/"
											   min="1" [max]="partner.maxUsers" style="max-width: 120px;"/>
									</div>
								</form>
							</div>

							<div class="flex-column p-3 rounded mb-2" style="background-color: #f9f9fa; font-size: 14px;">
								<div class="flex-row justify-content-between mb-3 pb-2" style="border-bottom: 1px solid #e5e5e5;">
									<span>PRO User - Per User Annually</span>
									<span>${{price_yearly}}</span>
								</div>
								<div class="flex-row justify-content-between">
									<span>Total Amount</span>
									<span style="font-size: 1.1rem;">${{(price_yearly * numUsers) | number : '1.2-2'}}</span>
								</div>
							</div>

							<div class="d-flex centralize py-2 w-100 rounded mb-3 gradient-primary"  style="cursor: pointer;"
								 (click)="openPurchasePopup();">
								<span style="text-align: center;"><i class="far fa-store me-1"></i>Proceed to Payment Form</span>
							</div>
							<div class="show-on-hover-container-1 w-100">
                                    <span class="d-block blue-link" style="width: 100%; text-align: center; cursor: pointer;">
                                        What will happen after I sign up and purchase?
                                    </span>
								<div class="show-on-hover-item-1 position-absolute shadow rounded border p-2" style="bottom: 80px; height: 100%; max-height: 345px; left: 50%; width: 80%; transform: translateX(-50%); background-color: white; z-index: 1040;">
									<ng-container *ngFor="let step of purchaseStepsInfo; let index = index;">
										<div class="flxClmn-around px-3" style="height: 100%; align-items: center;"
											 *ngIf="purchaseStepsChosenIdx === index">
											<div class="flxRow-center" style="align-items: center; border-radius: 50%; background: #7fb7dc; height: 65px; width: 65px;">
												<i style="font-size: 28px; color: white;" [ngClass]="step.iconClass"></i>
											</div>
											<span class="mb-2" style="text-align: center; font-size: 19px; color: #7fb7dc;">Step {{index + 1}}</span>
											<div class="flxClmn-center vSpace2">
                                                <span style="color: #5687a7; text-align: center; font-size: 14px; line-height: 1.3;"
													  [innerHTML]="step.text">
                                                </span>
												<span style="text-align: center; font-size: 14px; color: #7fb7dc;"
													  [innerHTML]="step.subText">
                                                </span>
											</div>
											<div class="flex-column gap-3 pb-2 mt-auto w-100">
												<div class="flxRow-center hSpace1">
													<div *ngFor="let purchaseStep of purchaseStepsInfo; let index = index;"
														 style="background: #7fb7dc; border-radius: 50%; cursor: pointer; width: 12px; height: 12px;"
														 (click)="purchaseStepsChosenIdx = index"
														 [ngStyle]="{'opacity' : purchaseStepsChosenIdx === index ? '1' : '0.5'}"></div>
												</div>
												<div class="flxRow-around" style="font-size: 16px; color: #5687a7; cursor: pointer;">
													<div class="flxRow hSpace1" style="transition: opacity 0.15s;"
														 [ngClass]="{'disabled-overlay' : purchaseStepsChosenIdx === 0}"
														 (click)="navigatePurchaseSteps('previous')">
														<i class="far fa-chevron-left" ></i>
														<span>previous</span>
													</div>
													<div class="flxRow hSpace1" style="transition: opacity 0.15s;"
														 (click)="navigatePurchaseSteps('next')"
														 [ngClass]="{'disabled-overlay' : purchaseStepsChosenIdx === purchaseStepsInfo.length - 1}">
														<span>next</span>
														<i class="far fa-chevron-right"></i>
													</div>
												</div>
											</div>
										</div>
									</ng-container>
								</div>
							</div>

							<span class="mt-2" style="font-size: 12px; text-align: center;">By purchasing, you agree to our <a class="blue-link fw-500 no-underline hvr-underline" target="_blank" rel="noopener noreferrer nofollow" href="{{eula}}">Terms of Use</a>, <a class="blue-link fw-500 no-underline hvr-underline" target="_blank" rel="noopener noreferrer nofollow" href="{{privacy}}">Privacy</a>, and <a class="blue-link fw-500 no-underline hvr-underline" target="_blank" rel="noopener noreferrer nofollow" href="{{antiSpam}}">Anti-Spam Policy</a></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Skip warning label popup-->
<popup-c *ngIf="purchasePopup?.show"
		 head="Purchase Confirmation"
		 (closeCb)="purchasePopup = null"
		 size="medium">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<stripe-buttons-component style="flex-grow: 1;"
			[hasAccessToken]="false"
			[type]="dic.CONSTANTS.paypalPaymentType.newUser"
			[partner]="partner"
			[numUsers]="numUsers"
			[couponCode]="couponCode"
			[accountDetails]="signupData.accountDetails"
			[priceId]="selectedPrice?.id"
			(onComplete)="paymentComplete($event.err, $event.res)">
		</stripe-buttons-component>
	</div>
</popup-c>


<!--((coupon template))-->
<ng-template #couponInput>
	<div class="flex-row justify-content-end">
		<div class="flex-row gap-2 pt-3 align-items-center f-1-0" *ngIf="!isCouponApplied">
			<span>Enter coupon code:</span>
			<input type="text"
				   [disabled]="isCouponApplied"
				   (keyup.enter)="applyCoupon()"
				   [ngClass]="{'disabled bg-transparent fw-bold border-0 opacity-100 f-1-0' : isCouponApplied}"
				   [(ngModel)]="couponCodeModel" style="width: 100px;">
			<btn-c style="min-width: 0;"
				   *ngIf="!isCouponApplied"
				   endIcon="zmdi zmdi-check"
				   (action)="applyCoupon()">
			</btn-c>
			<span class="text-success fw-500" *ngIf="isCouponApplied">${{priceSaved}} off per license</span>
		</div>
	</div>
</ng-template>
<!---->
